const ECP_APPLIANCE_ID_PATTERN = /^(\d+)_(\d+):(\d+)-(\w+)$/;
const DELTA_APPLIANCE_ID_PATTERN = /\d{24}/;
const OCP_APPLIANCE_IDENTITY_PATTERN = /^(\d+):(\d+)_(\d+):(\d+)-(\w+)$/;

export const isValidDeltaApplianceId = (applianceId: string): boolean => {
  return DELTA_APPLIANCE_ID_PATTERN.test(applianceId);
};

export const isValidOcpApplianceId = (applianceId: string): boolean => {
  return OCP_APPLIANCE_IDENTITY_PATTERN.test(applianceId);
};

export const isValidEcpApplianceId = (applianceId: string): boolean => {
  return ECP_APPLIANCE_ID_PATTERN.test(applianceId);
};

type UrlParams = {
  path?: string;
  queryParams?: {
    [key: string]: string | number;
  };
};

export function buildUrl(baseUrl: string, params?: UrlParams) {
  let finalUrl = baseUrl.trim();
  if (params?.path) {
    const path = !params.path.trim().startsWith('/')
      ? `/${params.path.trim()}`
      : params.path.trim();
    finalUrl += path.replace(/\/{2,}/gm, '/');
  }
  if (params?.queryParams) {
    if (!finalUrl.endsWith('?')) finalUrl += '?';
    for (const [key, value] of Object.entries(params.queryParams)) {
      finalUrl += `${key}=${encodeURIComponent(value)}&`;
    }
    finalUrl = finalUrl.slice(0, finalUrl.length - 1);
  }
  return finalUrl;
}
